import React from 'react';
import { SvgIcon } from '@material-ui/core';
const Add = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { viewBox: "0 0 16 16" }),
    React.createElement("path", { d: "M7.25 0.75C7.25 0.335786 7.58579 0 8 0C8.41421 0 8.75 0.335786 8.75 0.75V15.25C8.75 15.6642 8.41421 16 8 16C7.58579 16 7.25 15.6642 7.25 15.25V0.75Z" }),
    React.createElement("path", { d: "M15.25 7.25C15.6642 7.25 16 7.58579 16 8C16 8.41421 15.6642 8.75 15.25 8.75L0.75 8.75C0.335786 8.75 -1.81058e-08 8.41421 0 8C1.81058e-08 7.58579 0.335787 7.25 0.75 7.25L15.25 7.25Z" })));
export default Add;
